import { useEffect, useState } from "react";
import { ISelectModelDescriptionProps } from "./SelectModelsInterfaces";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import { fetchGetDocuments } from "../../api/simDocuments/DocumentService";
import { DocumentStruct } from "../../common/Interfaces";
import { SelectDocumentState } from "../../routing/RoutingStates";
import { useNavigate } from "react-router-dom";

export default function SelectModelDescription({
  modelState,
  selectedModels,
  selectedArchivedModels,
}: ISelectModelDescriptionProps) {
  const [loadDocuments, setLoadDocuments] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [documentResults, setDocumentResults] = useState<DocumentStruct[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const documentsList = await fetchGetDocuments({
            ProductCompany: modelState.selectedCompany?.key || "",
            SerialNumber: "",
            Models: [
              ...selectedModels.map((model) => model.key),
              ...selectedArchivedModels.map((model) => model.key),
            ],
            ProductNumbers: null,
            token,
          });
          setDocumentResults(documentsList || []);
        } catch (error: any) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            const messages = errors.map((err: any) => err.message);
            setErrorMessages(messages);
          }
        } finally {
          setLoadDocuments(false);
        }
      }
    };

    if (loadDocuments) {
      setErrorMessages([]);
      setDocumentResults([]);
      fetchData();
    }
  }, [loadDocuments]);

  useEffect(() => {
    if (!loadDocuments && documentResults.length > 0) {
      const selectDocumentState: SelectDocumentState = {
        basicMachineInformationResults: [],
        documentResults: documentResults,
      };
      navigate("ViewDocuments", {
        state: { selectDocumentState },
      });
    }
  }, [loadDocuments, documentResults]);

  useEffect(() => {
    setErrorMessages([]);
  }, [selectedModels, selectedArchivedModels]);
  const viewList = () => {
    setLoadDocuments(true);
  };

  return (
    <Row>
      <Col xs={9}>
        <Row>
          <Col xs={4}>
            <Row>
              <label>
                {modelState.isProductCompany
                  ? "Product Company :"
                  : "External Company :"}
              </label>
            </Row>
            {modelState.selectedProductRange && (
              <Row>
                <label className="padding-top">Product Range :</label>
              </Row>
            )}
          </Col>
          <Col xs={6}>
            <Row>
              <label>
                {modelState.selectedCompany?.key}
                {modelState.selectedCompany?.label != "deselect" &&
                  " / " + modelState.selectedCompany?.label}
              </label>
            </Row>
            {modelState.selectedProductRange && (
              <Row>
                <label className="padding-top">
                  {modelState.selectedProductRange}
                </label>
              </Row>
            )}
          </Col>
        </Row>
      </Col>
      <Col xs={3}>
        {loadDocuments ? (
          <Spinner animation="border" />
        ) : (
          <Button
            className="btn btn-primary"
            onClick={viewList}
            disabled={
              selectedModels.length === 0 && selectedArchivedModels.length === 0
            }
          >
            View List
          </Button>
        )}
        {errorMessages.map((errorMessage, index) => (
          <label key={index} className="errorMessage">
            {errorMessage}
          </label>
        ))}
      </Col>
    </Row>
  );
}
